// @flow

import { i18n } from 'shared/utils';
import type { FilterOption } from 'main-app/components/FilterControls';

export default (): Array<FilterOption> => [
  {
    label: i18n.t('Customer'),
    name: 'customerIds',
    type: 'customer',
    multi: true,
  },
  {
    label: i18n.t('Status'),
    name: 'statuses',
    type: 'select',
    multi: true,
    selectOptions: [
      { label: i18n.t('Draft'), value: 'DRAFT' },
      { label: i18n.t('Sent'), value: 'SENT' },
      { label: i18n.t('Partially Paid'), value: 'PARTIALLY_PAID' },
      { label: i18n.t('Paid'), value: 'PAID' },
      { label: i18n.t('Overdue'), value: 'OVERDUE' },
      { label: i18n.t('Void'), value: 'VOID' },
    ],
  },
  {
    label: i18n.t('Issue Date'),
    name: 'issueDate',
    type: 'date-range',
  },
  {
    label: i18n.t('Due Date'),
    name: 'dueDate',
    type: 'date-range',
  },
];
